import { EnumProducts } from "services/caju/enums/enumProducts";
import { Solutions, Subscriptions } from "./productConstants";

export interface ProductMapping {
  solutions: string[];
  subscriptions: string[];
}

/**
 * Maps UI products to backend solutions and subscription products.
 * Solutions: Main product offerings (Benefits, Expenses, Awards)
 * Subscriptions: Add-on services (People Management, Health & Wellness)
 */
export const productMappings: Record<EnumProducts, ProductMapping> = {
  [EnumProducts.MULTIBENEFITS]: {
    solutions: [
      Solutions.MULTIBENEFITS_VR_VA,
      Solutions.MULTIBENEFITS_FLEXIBLE,
    ],
    subscriptions: [],
  },
  [EnumProducts.CORP_EXPENSES]: {
    solutions: [Solutions.EXPENSES],
    subscriptions: [],
  },
  [EnumProducts.AWARDS]: {
    solutions: [Solutions.AWARDS],
    subscriptions: [],
  },
  [EnumProducts.CAJU_CICLOS]: {
    solutions: [],
    subscriptions: [Subscriptions.PEOPLE_MANAGEMENT],
  },
  [EnumProducts.CAJU_MAIS]: {
    solutions: [],
    subscriptions: [
      Subscriptions.HEALTH_NR1,
      Subscriptions.HEALTH_WELLHUB,
      Subscriptions.HEALTH_OPTUM_CONEXA,
    ],
  },
};

/**
 * Calculates the solutions and subscription products based on selected products
 * @param selectedProducts - Array of selected product IDs
 * @returns Object containing arrays of solutions and subscriptions
 */
export function calculateProductMappings(selectedProducts: EnumProducts[]): {
  solutions: string[];
  subscriptions: string[];
} {
  const allSolutions = new Set<string>();
  const allSubscriptions = new Set<string>();

  selectedProducts.forEach((product) => {
    const mapping = productMappings[product];
    mapping.solutions.forEach((s) => allSolutions.add(s));
    mapping.subscriptions.forEach((s) => allSubscriptions.add(s));
  });

  return {
    solutions: Array.from(allSolutions),
    subscriptions: Array.from(allSubscriptions),
  };
}
